import { render, staticRenderFns } from "./Armip.vue?vue&type=template&id=346e5349"
import script from "./Armip.vue?vue&type=script&lang=js"
export * from "./Armip.vue?vue&type=script&lang=js"
import style0 from "./Armip.vue?vue&type=style&index=0&id=346e5349&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_bbcd016e015477a3ecf09e87b6c3f580/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports